export default __webpack_public_path__ + "static/media/personal-setting.8ff9d7f0.svg";